import _classCallCheck from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
var h = Object.defineProperty;

var d = function d(s, t, e) {
  return t in s ? h(s, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : s[t] = e;
};

var n = function n(s, t, e) {
  return d(s, typeof t != "symbol" ? t + "" : t, e), e;
};

var p = function p(s) {
  if (typeof s != "object") try {
    return JSON.parse(s);
  } catch (t) {
    return console.error(t), new l();
  }
  return new l();
},
    i = function i(s) {
  try {
    return JSON.stringify(s);
  } catch (t) {
    return console.error(t), "";
  }
},
    u = function u() {
  return y();
},
    y = function y() {
  return window.location.href.split("#")[1];
},
    a = "smp_child_load_finished",
    c = "smp_send_stored_parent_data",
    g = "event_message",
    m = "message";

var l = function l() {
  _classCallCheck(this, l);

  n(this, "type", "");
  n(this, "data", null);
  n(this, "key", "");
};

var w = function w(t, e) {
  var _this = this;

  _classCallCheck(this, w);

  n(this, "targetOrigin", "");
  n(this, "contentWindow", null);
  n(this, "parentData", null);
  n(this, "eventListener", null);
  n(this, "initiateHandshake", function () {
    _this.contentWindow !== null && _this.contentWindow !== void 0 ? _this.listenForEvents(function (e) {
      e.type === a && _this.sendDataToChild(_this.parentData);
    }) : _this.sendDataToParent({
      type: a,
      data: null
    });
  });
  n(this, "setParentData", function (t, e) {
    var r = {
      data: t,
      type: c,
      key: e
    };

    try {
      _this.parentData = r;
    } catch (o) {
      console.error("Wrong Json structure has been passed to setParentData Function", o);
    }
  });
  n(this, "sendDataToChild", function (t) {
    var r;
    var e = i(t);

    try {
      (r = _this.contentWindow) == null || r.postMessage(e, _this.targetOrigin);
    } catch (o) {
      console.error("Please pass the iframe.contentWindow to the CommunicationsLibrary constructor, see docs", o);
    }
  });
  n(this, "sendDataToParent", function (t) {
    t.key = u();
    var e = i(t);

    try {
      window.parent.postMessage(e, _this.targetOrigin);
    } catch (r) {
      console.error(r);
    }
  });
  n(this, "listenForEvents", function (t) {
    _this.eventListener = function (e) {
      var r = p(e.data);

      _this.callback(r, t);
    }, window.addEventListener(m, _this.eventListener);
  });
  n(this, "closeConnection", function () {
    removeEventListener("message", _this.eventListener);
  });
  n(this, "callback", function (t, e) {
    t && (t.type === a || t.type === c || t.type === g) && e(t);
  });
  this.targetOrigin = t, this.contentWindow = e;
};

export { a as CHILD_LOAD_FINISHED, w as CommunicationsLibrary, g as EVENT_MESSAGE, l as EventModel, c as PARENT_DATA };